import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./alertBox.css";
import Button from "../ThemeButton/ThemeButton";
import PropTypes from "prop-types";

const AlertBox = ({
  show,
  setShow,
  alertMessage,
  popImage,
  handleSubmitData,
  modalTitle = "Are you sure?",
  // handleSubmit = () => setShow(false),
  // handleOut,
  handleCancelClick,
  buttonSubmitText,
}) => {
  return (
    <div>
      <Modal show={show} className="alertBoxModal">
        <div className="contentContainerConfirmAlert">
          <Modal.Header closeButton>
            <div className="imgTitles">
              <img src={popImage} alt="icon" />
            </div>
            <Modal.Title>{modalTitle}</Modal.Title>
            <div className="modalBody">{alertMessage}</div>
          </Modal.Header>
          <Modal.Footer>
            <div className="buttonOk">
              <div className="cancelBtns">
                <Button value="Cancel" onClick={handleCancelClick}></Button>
              </div>
              <Button
                value={buttonSubmitText}
                onClick={handleSubmitData}
              ></Button>
            </div>
          </Modal.Footer>
        </div>
      </Modal>
    </div>
  );
};

AlertBox.proptype = {
  setShow: PropTypes.func,
  show: PropTypes.bool,
  title: PropTypes.string,
  alertMessage: PropTypes.string,
  buttonSubmitText: PropTypes.string,
  handleSubmitData: PropTypes.func,
};
export default AlertBox;
